"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _articleListing = _interopRequireDefault(require("../../styles/article-listing.css"));
var _dateLabelContainer = _interopRequireDefault(require("../date-label-container"));
var _articleListing2 = _interopRequireDefault(require("../article-listing.props/article-listing.defaultProps"));
var _articleListing3 = _interopRequireDefault(require("../article-listing.props/article-listing.propTypes"));
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString,
  handleNestedProp = dataUtils.handleNestedProp;
var getLinkData = function getLinkData(link) {
  return {
    url: renderEmptyString(link.url),
    label: renderEmptyString(link.label),
    priority: 'low'
  };
};
var ImageLayout = function ImageLayout(_ref) {
  var article = _ref.article,
    theme = _ref.theme,
    index = _ref.index,
    animated = _ref.animated,
    layout = _ref.layout;
  var isNewLayoutEnabled = article.articleInformation.enableNewLayout;
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: index,
    className: theme.row + " " + theme.marginBottom80 + " " + _articleListing["default"].layoutWrapper + " " + (animated && _articleListing["default"].animated) + " " + (layout === 'full image' ? _articleListing["default"].fullImage : ''),
    onClick: function onClick() {
      isNewLayoutEnabled && window.open(article.articleInformation.link.url, article.articleInformation.link.openNewTab && '_blank');
    },
    style: {
      cursor: isNewLayoutEnabled && 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-md-3'] + " " + theme['col-md-offset-1'] + " " + _articleListing["default"].backgroundWrapper
  }, isNewLayoutEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: _articleListing["default"].backgroundImageWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _articleListing["default"].backgroundImageNewLayout,
    style: {
      backgroundImage: "url(\"" + handleNestedProp(article, 'article.articleInformation.image.image') + "\")"
    },
    role: "img",
    "aria-label": handleNestedProp(article, 'article.articleInformation.image.altText'),
    title: handleNestedProp(article, 'article.articleInformation.image.altText')
  })), !isNewLayoutEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: _articleListing["default"].backgroundImage,
    style: {
      backgroundImage: "url(\"" + handleNestedProp(article, 'article.articleInformation.image.image') + "\")"
    },
    role: "img",
    "aria-label": handleNestedProp(article, 'article.articleInformation.image.altText'),
    title: handleNestedProp(article, 'article.articleInformation.image.altText')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-md-7'] + " " + _articleListing["default"].layoutText
  }, renderEmptyString(article.date) !== ' ' && !isNewLayoutEnabled && /*#__PURE__*/_react["default"].createElement(_dateLabelContainer["default"], {
    date: article.date,
    theme: theme
  }), renderEmptyString(article.articleInformation.sectionHeading) !== ' ' && /*#__PURE__*/_react["default"].createElement("h3", {
    className: theme.marginBottom20 + " " + (isNewLayoutEnabled ? theme.headingSix : theme.headingFour) + " " + (isNewLayoutEnabled && _articleListing["default"].textDecoration)
  }, article.articleInformation.sectionHeading), renderEmptyString(article.articleInformation.paragraph) !== ' ' && /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.marginBottom20 + " " + theme.smallType
  }, article.articleInformation.paragraph), renderEmptyString(article.articleInformation.link) !== ' ' && !isNewLayoutEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: _articleListing["default"].ctaWrapper
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: getLinkData(article.articleInformation.link)
  })), renderEmptyString(article.date) !== ' ' && isNewLayoutEnabled && /*#__PURE__*/_react["default"].createElement(_dateLabelContainer["default"], {
    date: article.date,
    theme: theme,
    time: article.articleInformation.readTime,
    isNewLayoutEnabled: isNewLayoutEnabled
  })));
};
ImageLayout.displayName = 'ImageLayout';
ImageLayout.defaultProps = {
  article: _articleListing2["default"].articles[0],
  index: 0,
  animated: false,
  theme: {}
};
var _default = ImageLayout;
exports["default"] = _default;